import PeFormWizard from '@pe-libs/react-components/build/components/PeFormWizard';
import { FormikType } from '@pe-libs/react-components/build/lib/types';
import React, { FC } from 'react';
import PeOnboardingPage1 from './PeOnboardingWizardPage1';
import PeOnboardingPage2 from './PeOnboardingWizardPage2';
import PeOnboardingPage3 from './PeOnboardingWizardPage3';
import useStyles from './styles';
import { ActionsType, FormValuesType } from './types';

type Props = {
  formik: FormikType<FormValuesType>;
} & ActionsType;

const PeOnboardingWizard: FC<Props> = ({ formik, actions }) => {
  const styles = useStyles();

  const page1 = React.useCallback((innerProps) => <PeOnboardingPage1 {...innerProps} actions={actions} />, []);
  const page2 = React.useCallback((innerProps) => <PeOnboardingPage2 {...innerProps} actions={actions} />, []);
  const page3 = React.useCallback((innerProps) => <PeOnboardingPage3 {...innerProps} actions={actions} />, []);

  return (
    <div className={styles.form}>
      <PeFormWizard
        formik={formik}
        pages={{
          page1,
          page2,
          page3,
        }}
      />
    </div>
  );
};

export default PeOnboardingWizard;
